module.exports = __webpack_public_path__ + "static/img-banana-split-77c20e0a0d1f6e60dc780c3d5711296a.jpg";